import React from 'react';
import { useTypewriter } from '../hooks/useTypewriter';

const ROLES = [
  'ML Engineering Leader',
  'Computer Vision Researcher',
  'AI Systems Architect',
  'Deep Learning Practitioner',
];

export default function Hero() {
  const typed = useTypewriter(ROLES);

  return (
    <section className="hero" id="home" aria-label="Introduction">
      {/* Animated dot grid */}
      <div className="hero__grid" aria-hidden="true" />
      <div className="hero__grid-fade" aria-hidden="true" />

      <div className="hero__content">
        {/* <div className="hero__badge">
          <span className="hero__badge-dot" aria-hidden="true" />
          Open to opportunities
        </div> */}

        <p className="hero__eyebrow">Sr Manager, Machine Learning Science</p>

        <h1 className="hero__name">
          Dhruvin <em>Patel</em>
        </h1>

        <p className="hero__typed" aria-live="polite">
          <span>{typed}</span>
          <span className="hero__cursor" aria-hidden="true">|</span>
        </p>

        <p className="hero__subtitle">
          Leading machine learning science at Cotality — from computer vision
          research to production AI systems at scale.
        </p>

        <div className="hero__rule" aria-hidden="true" />

        <div className="hero__actions">
          <a
            href="/others/resume_dhruvinpatel.pdf"
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn--primary"
          >
            <i className="fa fa-file-text-o" aria-hidden="true" />
            View Resume
          </a>
          <a
            href="https://github.com/dhruvin88"
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn--outline"
          >
            <i className="fa fa-github" aria-hidden="true" />
            GitHub
          </a>
        </div>

        <nav className="hero__social-row" aria-label="Social links">
          <a href="https://www.linkedin.com/in/dhruvin-patel88/" target="_blank" rel="noopener noreferrer">
            LinkedIn
          </a>
          <a href="https://github.com/dhruvin88" target="_blank" rel="noopener noreferrer">
            GitHub
          </a>
          <a href="https://twitter.com/dhruvin88" target="_blank" rel="noopener noreferrer">
            Twitter
          </a>
          <a href="mailto:dhruvinp895@gmail.com">
            Email
          </a>
        </nav>
      </div>

      <div className="hero__scroll" aria-hidden="true">
        <span className="hero__scroll-label">scroll</span>
        <div className="hero__scroll-line" />
      </div>
    </section>
  );
}
